/*
 * @Description: 项目执行人数统计
 * @Date: 2024-01-15 14:09:19
 */
import BiTmplDetail_5 from './bi-tmpl-detail-5.vue';
export default BiTmplDetail_5;
